export default __webpack_public_path__ + "static/media/milestone 1200.662843b5.svg";